<template>
  <section class="employers-lt-order  container" id="employers-lt-order">
    <div class="employers-lt-order__content  container-inner">
      <h2 class="employers-lt-order__title">{{ section.heading }}</h2>

      <div class="employers-lt-order__inputs-list">
        <BaseInput :label="section.field1"
                   v-model="inputs.company_name.value"
                   :error="inputs.company_name.error"
                   :required="inputs.company_name.required"
                   class="employers-lt-order__input _company-name"/>
        <BaseInput :label="section.field2"
                   v-model="inputs.company_code.value"
                   :error="inputs.company_code.error"
                   :required="inputs.company_code.required"
                   class="employers-lt-order__input  _company-code"/>
        <BaseInput :label="section.field3"
                   v-model="inputs.firstname.value"
                   :error="inputs.firstname.error"
                   :required="inputs.firstname.required"
                   class="employers-lt-order__input  _first-name"/>
        <BaseInput :label="section.field4"
                   v-model="inputs.lastname.value"
                   :error="inputs.lastname.error"
                   :required="inputs.lastname.required"
                   class="employers-lt-order__input  _second-name"/>
        <BaseInput :label="section.field5"
                   v-model="inputs.position.value"
                   :error="inputs.position.error"
                   :required="inputs.position.required"
                   class="employers-lt-order__input"/>
        <BaseInputPhone :key="key"
                        :label="section.field6"
                        v-model="inputs.phone.value"
                        :error="inputs.phone.error"
                        :required="inputs.phone.required"
                        defaultCountry="lt"
                        class="employers-lt-order__input  _phone"/>
        <BaseInput :label="section.field7"
                   v-model="inputs.email.value"
                   :error="inputs.email.error"
                   :required="inputs.email.required"
                   type="email"
                   class="employers-lt-order__input  _email"/>
        <BaseInput :label="section.field8"
                   v-model="inputs.what_profession.value"
                   :error="inputs.what_profession.error"
                   :required="inputs.what_profession.required"
                   class="employers-lt-order__input  _profession"/>
        <BaseInput :label="section.field9"
                   v-model="inputs.how_many_persons.value"
                   :error="inputs.how_many_persons.error"
                   :required="inputs.how_many_persons.required"
                   type="number"
                   class="employers-lt-order__input  _employees-quantity"/>
        <BaseInput :label="section.field10"
                   v-model="inputs.salary.value"
                   :error="inputs.salary.error"
                   :required="inputs.salary.required"
                   class="employers-lt-order__input  _salary"/>
        <BaseInput :label="section.field11"
                   v-model="inputs.housing.value"
                   :error="inputs.housing.error"
                   :required="inputs.housing.required"
                   class="employers-lt-order__input"/>
        <p class="employers-lt-order__input-note">{{
            section.field12
          }}</p>
        <BaseInput :label="section.field13"
                   v-model="inputs.about_work.value"
                   :error="inputs.about_work.error"
                   :required="inputs.about_work.required"
                   textarea
                   class="employers-lt-order__input"/>
      </div>

      <div class="employers-lt-order__photos-upload-title">{{ section.field14 }}</div>
      <FilesUploadMultiple v-model="workPlacePhotos"
                           :filesExtsMixin="filesExtsMixin"
                           :filesMimeTypes="filesMimeTypes"
                           class="employers-lt-order__photos-upload"/>

      <BaseAlertInline :value="overallErrorsMix"
                       class="employers-lt-order__error  _error"/>

      <button @click.prevent="send"
              class="employers-lt-order__btn  base-btn  base-btn--outline-blue">
        <span>{{ section.button }}</span>
        <BasePreloader v-if="pending"
                       class="_small"/>
      </button>
    </div>
  </section>
</template>

<script>
  import formMixins from '@/mixins/formMixins'
  import FilesUploadMultiple from '@/components/FilesUploadMultiple'
  import BaseAlertInline from '@/components/BaseAlertInline'
  import {http} from '@/axios'
  import {
    ALLOWED_IMAGES_EXTS,
    ALLOWED_VIDEOS_EXTS,
    IMAGES_MIME_TYPES,
    VIDEOS_MIME_TYPES,
  } from '@/constants/files'

  function getInputs(vm) {
    return {
      company_name: {
        value: null,
        required: true
      },
      company_code: {
        value: null,
        required: true
      },
      firstname: {
        value: null,
        required: true
      },
      lastname: {
        value: null,
        required: true
      },
      position: {
        value: null,
        required: false
      },
      phone: {
        value: null,
        required: true
      },
      email: {
        value: null,
        required: true,
        validate: [{
          regexp: '([\\w\\.\\-_]+)?\\w+@[\\w-_]+(\\.\\w+){1,}',
          error: vm.section.invalid_email
        }]
      },
      what_profession: {
        value: null,
        required: true
      },
      how_many_persons: {
        value: null,
        required: true
      },
      salary: {
        value: null,
        required: true
      },
      housing: {
        value: null,
        required: true
      },
      about_work: {
        value: null,
        required: true
      },
    }
  }

  export default {
    name: 'EmployersLTPageOrder',
    mixins: [formMixins],
    components: {
      FilesUploadMultiple,
      BaseAlertInline,
    },
    props: {
      section: Object
    },
    data(vm) {
      return {
        key: 1,
        pending: null,
        inputs: getInputs(vm),
        workPlacePhotos: [],
        filesExtsMixin: [...ALLOWED_IMAGES_EXTS, ...ALLOWED_VIDEOS_EXTS],
        filesMimeTypes: [...IMAGES_MIME_TYPES, ...VIDEOS_MIME_TYPES],
      }
    },
    methods: {
      reset() {
        this.inputs = getInputs(this)
        this.key = ++this.key
        this.workPlacePhotos = []
      },
      send() {
        this.resetErrorsMix()

        const inputs = this.inputs
        const photos = this.workPlacePhotos
        const formData = new FormData()

        let someError = false

        for (const key in inputs) {
          let input = inputs[key]
          let value = input.value
          value = value === null ? '' : value


          if (input.required && value === '') {
            this.$set(input, 'error', [
              this.section.required_field + ' '
            ])

            someError = true
          }

          if (this.$get(input, 'validate.length')) {
            input.validate.forEach(validation => {
              if (!new RegExp(validation.regexp).test(String(value))) {
                if (!Array.isArray(input.error)) {
                  this.$set(input, 'error', [])
                }

                input.error.push(validation.error + ' ')
              }
            })
          }

          formData.append(key, value)
        }

        if (someError) {
          this.overallErrorsMix = this.section.contains_error + ' '
          return
        }

        for (const photo of photos) {
          formData.append('photos[]', photo.file)
        }

        this.pending = true

        http.post('/api/helper/landing/employer-lithua-send', formData)
          .then(() => {
            this.$vModal.open('successfully-sent', {
              title: this.section['modal_successfully_sent_title'],
              text: this.section['modal_successfully_sent_text'],
              button: this.section['modal-successfully-sent-button'],
            })

            this.reset()
          })
          .catch(e => {
            this.errorHandlerMix(e, this.inputs)
          })
          .finally(() => {
            this.pending = false
          })
      }
    }
  }
</script>

<style lang="less">

</style>
